import { useTranslation } from 'react-i18next'
import { Globe } from 'lucide-react'

const languages = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
] as const

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation()

  return (
    <div className="space-y-2">
      <div className="text-muted-foreground flex items-center gap-2 text-sm font-medium">
        <Globe className="h-4 w-4" />
        {t('settings.language')}
      </div>
      <div className="flex gap-2">
        {languages.map(({ code, label }) => (
          <button
            key={code}
            onClick={() => i18n.changeLanguage(code)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              i18n.resolvedLanguage === code
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}
